import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loandistribution',
  templateUrl: './loandistribution.component.html',
  styleUrls: ['./loandistribution.component.css']
})
export class LoandistributionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
